angular.module('invoice')
    .component('invoiceSettlementsForInvoice', {
        bindings: {
            invoiceId: '<',
            invoice: '<',
            onSettlementChanged: '&',
            onDataLoaded: '&?'
        },
        templateUrl: 'app/invoice/_settlements.html',
        controller: function ($scope, $state, Invoice, InvoiceService, InvoiceSettlement, InvoiceSettlementService, InvoiceConst, InvoiceSettlementConst, Principal) {
            this.InvoiceService = InvoiceService
            this.InvoiceSettlementService = InvoiceSettlementService

            this.$onInit = () => {
                Invoice.settlements({id: this.invoiceId}).$promise
                    .then(items => {
                        this.settlements = items
                        this.onDataLoaded({$count: items.length})
                    })
                    .catch(() => {
                        this.settlements = []
                        this.onDataLoaded({$count: 0})
                    })
                this.isAccountant = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING'])
                this.isManager = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ALL', 'ROLE_ADMIN'])
                this.isAccountantOrManager = this.isAccountant || this.isManager
                this.canSeeHistory = this.isAccountantOrManager
            }

            this.addSettlement = () => InvoiceSettlementService.add(this.invoice)

            $scope.$on(InvoiceConst.eventUpdate, () => this.$onInit())
            $scope.$on(InvoiceSettlementConst.eventUpdate, () => {
                this.$onInit()
                this.onSettlementChanged()
            })
        }
    })
